import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateChannelGuideDocument } from './create.generated';

export const useCreateChannelGuide = (
  options: ApiOptions<typeof CreateChannelGuideDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateChannelGuideDocument, {
    ...useNotifications(CreateChannelGuideDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.channel_guides.create_success'),
    }),

    ...options,
  });
};
